import { defineMessages } from 'react-intl';

export const scope = 'app.components.ParentLoginNotice';

export const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Parent or guardian? This is NOT your sign-in page.',
  },
  body: {
    id: `${scope}.body`,
    defaultMessage: 'This page is for sports association staff only. Parents sign in on the Parent page with a one-time code — no password needed.',
  },
  btnGoToParent: {
    id: `${scope}.btnGoToParent`,
    defaultMessage: 'Go to Parent Sign In',
  },
});
